// src/common/utilities/custom-utils.js
document.addEventListener("DOMContentLoaded", () => {
});

// src/sections/product-sticky-size.js
var syncStickySize = (radio) => {
  document.querySelectorAll("[data-sticky-size-value]").forEach((node) => {
    if (radio) node.textContent = radio.value;
  });
  document.querySelectorAll("[data-size-input]").forEach((row) => {
    row.classList.toggle("is-selected", Boolean(radio) && row.getAttribute("data-size-input") === radio.id);
  });
};
var mobileStickyQuery = window.matchMedia("(max-width: 699px)");
var observedStickyBars = /* @__PURE__ */ new WeakSet();
var stickyBarShown = /* @__PURE__ */ new WeakMap();
var preparedSheets = /* @__PURE__ */ new WeakSet();
var clearModalMotion = (modal) => {
  [modal, modal.getShadowPartByName?.("overlay"), modal.getShadowPartByName?.("content")].filter(Boolean).forEach((node) => {
    node.getAnimations().forEach((animation) => animation.cancel());
    node.style.removeProperty("opacity");
    node.style.removeProperty("transform");
  });
};
var prepareSizeSheet = (modal) => {
  if (preparedSheets.has(modal)) return;
  preparedSheets.add(modal);
  modal.addEventListener("dialog:before-show", () => clearModalMotion(modal));
  modal.addEventListener("dialog:after-hide", () => clearModalMotion(modal));
};
var isStickyBarShown = (bar) => {
  if (!bar?.isConnected) return false;
  if (mobileStickyQuery.matches) return true;
  return bar.classList.contains("is-visible");
};
var forceCloseSizeSheets = () => {
  document.querySelectorAll("x-modal.pdp-size-sheet[open]").forEach((modal) => {
    prepareSizeSheet(modal);
    if (typeof modal.hide === "function") modal.hide();
    else modal.removeAttribute("open");
  });
  syncStickySize(document.querySelector(".ProductForm__Option--size .SizeSwatch__Radio:checked"));
};
var evaluateStickyBar = (bar) => {
  const shown = isStickyBarShown(bar);
  if (stickyBarShown.get(bar) === true && !shown) forceCloseSizeSheets();
  stickyBarShown.set(bar, shown);
};
var observeStickyBar = (bar) => {
  if (observedStickyBars.has(bar)) return;
  observedStickyBars.add(bar);
  stickyBarShown.set(bar, isStickyBarShown(bar));
  const classObserver = new MutationObserver(() => evaluateStickyBar(bar));
  classObserver.observe(bar, { attributes: true, attributeFilter: ["class"] });
  const root = bar.closest(".shopify-section") || document.body;
  const removalObserver = new MutationObserver(() => {
    if (bar.isConnected) return;
    classObserver.disconnect();
    removalObserver.disconnect();
    evaluateStickyBar(bar);
    observedStickyBars.delete(bar);
    stickyBarShown.delete(bar);
  });
  removalObserver.observe(root, { childList: true, subtree: true });
};
var watchStickyBars = () => {
  document.querySelectorAll("product-sticky-bar").forEach(observeStickyBar);
};
var onSizeOptionClick = (event) => {
  const row = event.target.closest("[data-size-input]");
  if (!row || row.disabled) return;
  const radio = document.getElementById(row.getAttribute("data-size-input"));
  if (!radio) return;
  if (!radio.checked) {
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }
  syncStickySize(radio);
  row.closest("x-modal")?.hide();
};
var initStickySizePicker = () => {
  const checked = document.querySelector(".ProductForm__Option--size .SizeSwatch__Radio:checked");
  if (checked) syncStickySize(checked);
  document.querySelectorAll("x-modal.pdp-size-sheet").forEach(prepareSizeSheet);
  document.addEventListener("click", onSizeOptionClick);
  watchStickyBars();
  const root = document.querySelector(".shopify-section--main-product") || document.body;
  new MutationObserver(watchStickyBars).observe(root, { childList: true, subtree: true });
  mobileStickyQuery.addEventListener("change", () => {
    document.querySelectorAll("product-sticky-bar").forEach(evaluateStickyBar);
  });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStickySizePicker);
} else {
  initStickySizePicker();
}
//# sourceMappingURL=custom.js.map
